import { Link, Theme, Typography, useTheme } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import { Trans } from 'react-i18next';

export type TimelineAttributionLinkProps = {
  href: string;
  label: string;
};

/** "Powered by" attribution shown in the timeline layer controls. */
export const TimelineAttributionLink = ({
  href,
  label,
}: TimelineAttributionLinkProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      sx={{
        display: 'flex',
        flexShrink: 0,
        color: `${theme.vars.palette.text.secondary} !important`,
        textDecoration: 'none',
        textAlign: 'left',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          color: (t: Theme) => `${t.palette.text.secondary} !important`,
        }}
      >
        <Trans
          i18nKey="map.timeline.poweredBy"
          components={{
            1: <strong style={{ whiteSpace: 'nowrap', fontWeight: 600 }} />,
          }}
          values={{ label }}
        />
      </Typography>
      <LaunchIcon
        sx={{
          width: 12,
          height: 12,
          ml: '3px',
          position: 'relative',
          top: '1px',
        }}
      />
    </Link>
  );
};
